import _axios from '../../apiClient'

export function getTestData(payload) {
    return [
        { id: 1, name: 'test 1' },
        { id: 2, name: 'test 2' },
        { id: 3, name: 'test 3' },
        { id: 4, name: 'test 4' }
    ]
}